import React from 'react'
import clsx from 'clsx'

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: string
  hint?: string
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, hint, className, id, ...props }, ref) => {
    const generatedId = React.useId()
    const inputId = id ?? generatedId
    const descriptionId = `${inputId}-description`
    return (
      <div className="flex flex-col gap-1.5">
        {label && (
          <label htmlFor={inputId} className="text-[13px] font-medium" style={{ color: 'var(--text-secondary)' }}>
            {label}
          </label>
        )}
        <input
          ref={ref}
          id={inputId}
          aria-invalid={error ? true : undefined}
          aria-describedby={error || hint ? descriptionId : undefined}
          className={clsx(
            'h-10 px-3 rounded-lg text-[14px] transition-colors duration-150',
            'placeholder:text-[var(--text-hint)]',
            'focus:outline-none focus:ring-2 focus:ring-[var(--accent)] focus:ring-offset-1',
            error && 'ring-2 ring-[var(--danger)]',
            className
          )}
          style={{
            backgroundColor: 'var(--bg-secondary)',
            color: 'var(--text-primary)',
            border: `1px solid ${error ? 'var(--danger)' : 'var(--border)'}`,
          }}
          {...props}
        />
        {error && (
          <span id={descriptionId} className="text-[12px]" style={{ color: 'var(--danger)' }}>{error}</span>
        )}
        {hint && !error && (
          <span id={descriptionId} className="text-[12px]" style={{ color: 'var(--text-hint)' }}>{hint}</span>
        )}
      </div>
    )
  }
)

Input.displayName = 'Input'
